import { Action } from '@ngrx/store';
import { ChangeOwnershipNewOwnerModel } from '../pet-owner/change-ownership/Models/change-ownership-model';
import * as ChangeOwnershipNewOwnerAction from '../actions/change-ownership-new-owner.action';

const initialState: ChangeOwnershipNewOwnerModel = null

export function ChangeOwnershipNewOwnerReducer(state: ChangeOwnershipNewOwnerModel = initialState, action: ChangeOwnershipNewOwnerAction.Actions) {

    // Section 3
    switch(action.type) {
        case ChangeOwnershipNewOwnerAction.CREATE_CHANGEOWNERSHIPNEWOWNER:
            if (action.payload != state)
                state = action.payload;
            return state;
        default:
            return state;
    }
}